export const RAPORKETUNTASAN_GET = 'RAPORKETUNTASAN_GET';
export const RAPORKETUNTASANDETAIL_GET = 'RAPORKETUNTASANDETAIL_GET';